var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: "",
        scrollable: "",
        transition: "dialog-bottom-transition",
        "content-class": "sc-indicators-dialog",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm.dialog
        ? _c("div", { staticClass: "sc-indicators" }, [
            _c(
              "div",
              { staticClass: "sc-indicators__topbar" },
              [
                _c("ds-icon", {
                  attrs: {
                    name: "monitoring",
                    size: 22,
                    color: "var(--blue-700)",
                  },
                }),
                _c("span", { staticClass: "sc-indicators__topbar-title" }, [
                  _vm._v("Indicadores de Gestão Docente"),
                ]),
                _c("span", { staticClass: "sc-indicators__spacer" }),
                _c("ds-icon-button", {
                  attrs: { icon: "close", label: "Fechar" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "sc-indicators__body",
                class: { "sc-carregando": _vm.carregandoIndicadores },
              },
              [
                _c(
                  "div",
                  { staticClass: "sc-filterbar" },
                  [
                    _c(
                      "div",
                      { staticClass: "sc-field" },
                      [
                        _c("sys-select-company", {
                          attrs: {
                            model: _vm.empresasSelecionadas,
                            label: "Empresas",
                            multiple: "",
                            autoComplete: "",
                            dense: "",
                            clearable: "",
                            showCheckbox: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              _vm.empresasSelecionadas = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sc-field" },
                      [
                        _c("sys-select-course", {
                          attrs: {
                            model: _vm.cursosSelecionados,
                            label: "Cursos",
                            multiple: "",
                            autoComplete: "",
                            dense: "",
                            clearable: "",
                            hideDetails: "",
                            showCheckbox: "",
                            onlyActive: true,
                            onlyWithGroups: true,
                          },
                          on: {
                            "update:model": function ($event) {
                              _vm.cursosSelecionados = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sc-field" },
                      [
                        _c("sys-select-teacher-combo", {
                          attrs: {
                            model: _vm.professoresSelecionados,
                            label: "Professor",
                            dense: "",
                            clearable: "",
                            showCheckbox: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              _vm.professoresSelecionados = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "ds-button",
                      {
                        attrs: {
                          icon: "filter_alt",
                          disabled:
                            !_vm.filtrosPendentes || _vm.carregandoIndicadores,
                          title:
                            "Atualiza os indicadores com as empresas, cursos e professores selecionados",
                        },
                        on: { click: _vm.aplicarFiltros },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.carregandoIndicadores
                              ? "Atualizando…"
                              : "Aplicar filtros"
                          )
                        ),
                      ]
                    ),
                    _c(
                      "ds-button",
                      {
                        attrs: { variant: "secondary", icon: "tune" },
                        on: { click: _vm.abrirParam },
                      },
                      [_vm._v("Parametrizações")]
                    ),
                    _c(
                      "ds-button",
                      {
                        attrs: { variant: "quiet", icon: "filter_alt_off" },
                        on: { click: _vm.limparFiltros },
                      },
                      [_vm._v("Limpar filtros")]
                    ),
                  ],
                  1
                ),
                _vm.carregandoIndicadores
                  ? _c(
                      "div",
                      {
                        staticClass: "sc-loadbar",
                        attrs: {
                          role: "progressbar",
                          "aria-label": "Atualizando indicadores",
                        },
                      },
                      [_c("span")]
                    )
                  : _vm._e(),
                _vm.chipsEmpresas.length
                  ? _c(
                      "div",
                      { staticClass: "sc-chips" },
                      [
                        _c("span", { staticClass: "sc-chips__label" }, [
                          _vm._v("Empresas:"),
                        ]),
                        _vm._l(_vm.chipsEmpresas, function (c, i) {
                          return _c(
                            "button",
                            {
                              key: i,
                              staticClass: "sc-chip",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return c.remove()
                                },
                              },
                            },
                            [_vm._v(_vm._s(c.label) + " ×")]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.chipsCursos.length
                  ? _c(
                      "div",
                      { staticClass: "sc-chips" },
                      [
                        _c("span", { staticClass: "sc-chips__label" }, [
                          _vm._v("Cursos:"),
                        ]),
                        _vm._l(_vm.chipsCursos, function (c, i) {
                          return _c(
                            "button",
                            {
                              key: i,
                              staticClass: "sc-chip",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return c.remove()
                                },
                              },
                            },
                            [_vm._v(_vm._s(c.label) + " ×")]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.chipsProfessores.length
                  ? _c(
                      "div",
                      { staticClass: "sc-chips" },
                      [
                        _c("span", { staticClass: "sc-chips__label" }, [
                          _vm._v("Professores:"),
                        ]),
                        _vm._l(_vm.chipsProfessores, function (c, i) {
                          return _c(
                            "button",
                            {
                              key: i,
                              staticClass: "sc-chip",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return c.remove()
                                },
                              },
                            },
                            [_vm._v(_vm._s(c.label) + " ×")]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.chips.length
                  ? _c(
                      "div",
                      { staticClass: "sc-chips" },
                      [
                        _c("span", { staticClass: "sc-chips__label" }, [
                          _vm._v("Filtros aplicados:"),
                        ]),
                        _vm._l(_vm.chips, function (c, i) {
                          return _c(
                            "button",
                            {
                              key: i,
                              staticClass: "sc-chip",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return c.remove()
                                },
                              },
                            },
                            [_vm._v(_vm._s(c.label) + " ×")]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "sc-conformidade" },
                  _vm._l(_vm.conformidade, function (c, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "ds-card sc-conformidade-card",
                        style: { borderLeftColor: c.cor },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "sc-conformidade-card__top" },
                          [
                            _c("ds-icon", {
                              attrs: { name: c.icone, size: 17, color: c.cor },
                            }),
                            _c(
                              "span",
                              { staticClass: "sc-conformidade-card__titles" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "sc-conformidade-card__titulo",
                                  },
                                  [_vm._v(_vm._s(c.titulo))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sc-conformidade-card__subtitulo",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(c.subtitulo) +
                                        " (" +
                                        _vm._s(c.alvo) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("span", { staticClass: "sc-flex1" }),
                            _c(
                              "span",
                              { staticClass: "sc-conformidade-card__valor" },
                              [_vm._v(_vm._s(c.valor))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "sc-status-pill",
                                style: { color: c.cor, background: c.fundo },
                              },
                              [_vm._v(_vm._s(c.status))]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sc-conformidade-card__bottom" },
                          [
                            _c("span", { staticClass: "sc-progress-track" }, [
                              _c("span", {
                                staticClass: "sc-progress-fill",
                                style: { width: c.largura, background: c.cor },
                              }),
                            ]),
                            _c(
                              "span",
                              { staticClass: "sc-conformidade-card__nota" },
                              [_vm._v(_vm._s(c.nota))]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "sc-kpi-panel" }, [
                  _c(
                    "div",
                    { staticClass: "sc-kpi-grid" },
                    [
                      _c("ds-stat-card", {
                        attrs: {
                          icon: "groups",
                          tone: 700,
                          label: "Docentes Ativos",
                          value: _vm.kpiAtivos.value,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "caption",
                              fn: function () {
                                return [
                                  _c("ds-legend", {
                                    attrs: {
                                      delta: _vm.kpiAtivos.delta,
                                      tooltip: _vm.kpiAtivos.tooltip,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3964349447
                        ),
                      }),
                      _c("ds-stat-card", {
                        attrs: {
                          icon: "assignment_ind",
                          tone: 500,
                          label: "CH Média Semanal",
                          value: _vm.kpiChMedia.value,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "caption",
                              fn: function () {
                                return [
                                  _c(
                                    "ds-legend",
                                    {
                                      attrs: {
                                        delta: _vm.kpiChMedia.delta,
                                        tooltip: _vm.kpiChMedia.tooltip,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "sc-mini-badge",
                                          attrs: {
                                            title:
                                              "Média da carga horária semanal atribuída, somando sala de aula e atividades extraclasse",
                                          },
                                        },
                                        [_vm._v("Sala de aula + atividades")]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1878089951
                        ),
                      }),
                      _c("ds-stat-card", {
                        attrs: {
                          icon: "work_history",
                          tone: 100,
                          label: "Tempo Integral",
                          value: _vm.kpiIntegralParcial.value,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "caption",
                              fn: function () {
                                return [
                                  _c(
                                    "ds-legend",
                                    {
                                      attrs: {
                                        pct: _vm.kpiIntegralParcial.pct,
                                        tooltip: _vm.kpiIntegralParcial.tooltip,
                                      },
                                    },
                                    [
                                      _vm.kpiIntegralParcial.meta
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "sc-meta-chip",
                                              class: _vm.kpiIntegralParcial.meta
                                                .ok
                                                ? "sc-meta-chip--ok"
                                                : "sc-meta-chip--bad",
                                              attrs: {
                                                title:
                                                  _vm.kpiIntegralParcial.meta
                                                    .tooltip,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Meta " +
                                                  _vm._s(
                                                    _vm.kpiIntegralParcial.meta
                                                      .texto
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2871107258
                        ),
                      }),
                      _c("ds-stat-card", {
                        attrs: {
                          icon: "workspace_premium",
                          tone: 900,
                          label: "Mestres e Doutores",
                          value: _vm.kpiStricto.value,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "caption",
                              fn: function () {
                                return [
                                  _c(
                                    "ds-legend",
                                    {
                                      attrs: {
                                        pct: _vm.kpiStricto.pct,
                                        tooltip: _vm.kpiStricto.tooltip,
                                      },
                                    },
                                    [
                                      _vm.kpiStricto.meta
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "sc-meta-chip",
                                              class: _vm.kpiStricto.meta.ok
                                                ? "sc-meta-chip--ok"
                                                : "sc-meta-chip--bad",
                                              attrs: {
                                                title:
                                                  _vm.kpiStricto.meta.tooltip,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Meta " +
                                                  _vm._s(
                                                    _vm.kpiStricto.meta.texto
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1446590970
                        ),
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "sc-section-toggle",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.regimeAberto = !_vm.regimeAberto
                      },
                    },
                  },
                  [
                    _c("ds-icon", {
                      attrs: {
                        name: "schedule",
                        size: 22,
                        color: "var(--blue-700)",
                      },
                    }),
                    _c("span", { staticClass: "sc-section-toggle__title" }, [
                      _vm._v("Regime de Trabalho"),
                    ]),
                    _c("ds-icon", {
                      attrs: {
                        name: _vm.regimeAberto ? "expand_less" : "expand_more",
                        size: 22,
                        color: "var(--text-muted)",
                      },
                    }),
                    _c("span", { staticClass: "sc-hr" }),
                    _c("span", { staticClass: "sc-section-toggle__valor" }, [
                      _vm._v(_vm._s(_vm.confRegime.valor)),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "sc-status-pill",
                        style: {
                          color: _vm.confRegime.cor,
                          background: _vm.confRegime.fundo,
                        },
                      },
                      [_vm._v(_vm._s(_vm.confRegime.status))]
                    ),
                  ],
                  1
                ),
                _vm.regimeAberto
                  ? [
                      _c(
                        "div",
                        { staticClass: "sc-kpi-grid sc-kpi-grid--sub" },
                        _vm._l(_vm.kpisRegime, function (k, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticClass: "sc-kpi-clickable",
                              style: {
                                opacity: k.opacidade,
                                boxShadow: k.anel,
                              },
                              attrs: { title: k.dica },
                              on: {
                                click: function ($event) {
                                  return _vm.setRegimeCat(k.cat)
                                },
                              },
                            },
                            [
                              _c("ds-stat-card", {
                                attrs: {
                                  icon: k.icon,
                                  tone: k.tone,
                                  label: k.label,
                                  value: k.value,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "caption",
                                      fn: function () {
                                        return [
                                          _c(
                                            "ds-legend",
                                            {
                                              attrs: {
                                                pct: k.pct,
                                                delta: k.delta,
                                                tooltip: k.tooltip,
                                              },
                                            },
                                            [
                                              k.meta
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "sc-meta-chip",
                                                      class: k.meta.ok
                                                        ? "sc-meta-chip--ok"
                                                        : "sc-meta-chip--bad",
                                                      attrs: {
                                                        title: k.meta.tooltip,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Meta " +
                                                          _vm._s(k.meta.texto)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _c("div", { staticClass: "sc-charts-row" }, [
                        _c("div", { staticClass: "ds-card sc-chart-card" }, [
                          _c("div", { staticClass: "sc-chart-title" }, [
                            _vm._v("% Professores por Regime de Trabalho"),
                          ]),
                          _c(
                            "svg",
                            {
                              staticClass: "sc-pie",
                              attrs: { viewBox: "0 0 200 200" },
                            },
                            [
                              _vm._l(_vm.regimePieReal.fatias, function (f, i) {
                                return _c("path", {
                                  key: i,
                                  attrs: {
                                    d: f.d,
                                    fill: f.fill,
                                    stroke: "#FFFFFF",
                                    "stroke-width": "1.5",
                                    opacity: f.opacidade,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return f.onClick()
                                    },
                                  },
                                })
                              }),
                              _vm._l(
                                _vm.regimePieReal.rotulos,
                                function (r, i) {
                                  return _c(
                                    "text",
                                    {
                                      key: "t" + i,
                                      attrs: {
                                        x: r.x,
                                        y: r.y,
                                        fill: r.fill,
                                        "font-size": "11",
                                        "font-weight": "500",
                                        "text-anchor": "middle",
                                      },
                                    },
                                    [_vm._v(_vm._s(r.texto))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "sc-legend-row" },
                            _vm._l(_vm.regimePieReal.legenda, function (l, i) {
                              return _c(
                                "button",
                                {
                                  key: i,
                                  staticClass: "sc-legend-item",
                                  style: {
                                    color: l.cor,
                                    background: l.fundo,
                                    opacity: l.opacidade,
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return l.onClick()
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "sc-legend-dot",
                                    style: { background: l.ponto },
                                  }),
                                  _vm._v(_vm._s(l.label) + " "),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "ds-card sc-chart-card sc-chart-card--wide",
                          },
                          [
                            _c("div", { staticClass: "sc-chart-header" }, [
                              _c("div", { staticClass: "sc-chart-title" }, [
                                _vm._v(
                                  "Quantidade de Professores por Curso e Regime de Trabalho"
                                ),
                              ]),
                              _c("div", { staticClass: "sc-chart-controls" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "sc-field",
                                    staticStyle: {
                                      flex: "1 1 180px",
                                      "min-width": "150px",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("Buscar curso"),
                                    ]),
                                    _c("ds-input", {
                                      attrs: {
                                        icon: "search",
                                        placeholder: "Nome do curso",
                                        value: _vm.cursoBusca,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.setCursoBusca($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "sc-field",
                                    staticStyle: { flex: "0 1 auto" },
                                  },
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("Ordenação"),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "sc-order-buttons" },
                                      _vm._l(_vm.ordemBotoes, function (o) {
                                        return _c(
                                          "button",
                                          {
                                            key: o.value,
                                            staticClass: "sc-order-btn",
                                            style: {
                                              color: o.cor,
                                              background: o.fundo,
                                            },
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setCursoOrdem(
                                                  o.value
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(o.label))]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "sc-bars" },
                              _vm._l(_vm.regimeChart.grupos, function (g, gi) {
                                return _c(
                                  "div",
                                  { key: gi, staticClass: "sc-bars__group" },
                                  _vm._l(g.barras, function (b, bi) {
                                    return _c(
                                      "button",
                                      {
                                        key: bi,
                                        staticClass: "sc-bars__bar",
                                        style: { opacity: b.opacidade },
                                        attrs: {
                                          type: "button",
                                          title: b.title,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return b.onClick()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "sc-bars__value",
                                            style: { color: b.cor },
                                          },
                                          [_vm._v(_vm._s(b.valor))]
                                        ),
                                        _c("span", {
                                          staticClass: "sc-bars__col",
                                          style: {
                                            height: b.altura,
                                            background: b.cor,
                                          },
                                        }),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              }),
                              0
                            ),
                            _c(
                              "div",
                              { staticClass: "sc-bars-labels" },
                              _vm._l(_vm.regimeChart.grupos, function (g, gi) {
                                return _c(
                                  "div",
                                  {
                                    key: gi,
                                    staticClass: "sc-bars-labels__item",
                                    attrs: { title: g.curso },
                                  },
                                  [_c("span", [_vm._v(_vm._s(g.rotulo))])]
                                )
                              }),
                              0
                            ),
                            _c("div", { staticClass: "sc-chart-footer" }, [
                              _c("span", { staticClass: "sc-muted-label" }, [
                                _vm._v(_vm._s(_vm.cursosTexto)),
                              ]),
                              _c(
                                "div",
                                { staticClass: "sc-chart-footer__actions" },
                                [
                                  _c(
                                    "ds-button",
                                    {
                                      attrs: { variant: "quiet", size: "sm" },
                                      on: { click: _vm.alternarCursosTodos },
                                    },
                                    [_vm._v(_vm._s(_vm.cursosRotuloTodos))]
                                  ),
                                  _c(
                                    "ds-button",
                                    {
                                      attrs: {
                                        variant: "secondary",
                                        size: "sm",
                                      },
                                      on: { click: _vm.cursoPaginaAnterior },
                                    },
                                    [_vm._v("Anterior")]
                                  ),
                                  _c(
                                    "ds-button",
                                    {
                                      attrs: {
                                        variant: "secondary",
                                        size: "sm",
                                      },
                                      on: { click: _vm.cursoPaginaProxima },
                                    },
                                    [_vm._v("Próxima")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "ds-card sc-ch-media-card" }, [
                        _c("div", { staticClass: "sc-chart-title" }, [
                          _vm._v("CH Média Docente por Regime de Trabalho"),
                        ]),
                        _c("div", { staticClass: "sc-chart-subtitle" }, [
                          _vm._v(
                            "Carga horária semanal média dos docentes ativos no recorte atual"
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "sc-ch-media-grid" },
                          _vm._l(_vm.chMedia, function (c, i) {
                            return _c(
                              "div",
                              {
                                key: i,
                                staticClass: "sc-ch-media-row",
                                style: { opacity: c.opacidade },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "sc-ch-media-row__label" },
                                  [_vm._v(_vm._s(c.label))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sc-progress-track sc-progress-track--tall",
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "sc-progress-fill sc-progress-fill--tall",
                                      style: {
                                        width: c.largura,
                                        background: c.cor,
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "sc-ch-media-row__valor" },
                                  [_vm._v(_vm._s(c.valor))]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _c("div", { staticClass: "sc-divider" }),
                        _c("div", { staticClass: "sc-ch-total" }, [
                          _c("span", [
                            _vm._v(
                              "CH total atribuída (sala de aula + atividades)"
                            ),
                          ]),
                          _c("span", { staticClass: "sc-ch-total__valor" }, [
                            _vm._v(_vm._s(_vm.chTotal) + " h/semana"),
                          ]),
                        ]),
                      ]),
                    ]
                  : _vm._e(),
                _c(
                  "button",
                  {
                    staticClass: "sc-section-toggle",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.titulacaoAberta = !_vm.titulacaoAberta
                      },
                    },
                  },
                  [
                    _c("ds-icon", {
                      attrs: {
                        name: "workspace_premium",
                        size: 22,
                        color: "var(--blue-700)",
                      },
                    }),
                    _c("span", { staticClass: "sc-section-toggle__title" }, [
                      _vm._v("Titulação"),
                    ]),
                    _c("ds-icon", {
                      attrs: {
                        name: _vm.titulacaoAberta
                          ? "expand_less"
                          : "expand_more",
                        size: 22,
                        color: "var(--text-muted)",
                      },
                    }),
                    _c("span", { staticClass: "sc-hr" }),
                    _c("span", { staticClass: "sc-section-toggle__valor" }, [
                      _vm._v(_vm._s(_vm.confTitulacao.valor)),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "sc-status-pill",
                        style: {
                          color: _vm.confTitulacao.cor,
                          background: _vm.confTitulacao.fundo,
                        },
                      },
                      [_vm._v(_vm._s(_vm.confTitulacao.status))]
                    ),
                  ],
                  1
                ),
                _vm.titulacaoAberta
                  ? [
                      _c(
                        "div",
                        { staticClass: "sc-kpi-grid sc-kpi-grid--sub" },
                        _vm._l(_vm.kpisTitulacao, function (k, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticClass: "sc-kpi-clickable",
                              style: {
                                opacity: k.opacidade,
                                boxShadow: k.anel,
                              },
                              attrs: { title: k.dica },
                              on: {
                                click: function ($event) {
                                  return _vm.setTituloCat(k.cat)
                                },
                              },
                            },
                            [
                              _c("ds-stat-card", {
                                attrs: {
                                  icon: k.icon,
                                  tone: k.tone,
                                  label: k.label,
                                  value: k.value,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "caption",
                                      fn: function () {
                                        return [
                                          _c("ds-legend", {
                                            attrs: {
                                              pct: k.pct,
                                              delta: k.delta,
                                              tooltip: k.tooltip,
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _c("div", { staticClass: "sc-charts-row" }, [
                        _c("div", { staticClass: "ds-card sc-chart-card" }, [
                          _c("div", { staticClass: "sc-chart-title" }, [
                            _vm._v("% Professores por Titulação"),
                          ]),
                          _c(
                            "svg",
                            {
                              staticClass: "sc-pie",
                              attrs: { viewBox: "0 0 200 200" },
                            },
                            [
                              _vm._l(
                                _vm.titulacaoPieReal.fatias,
                                function (f, i) {
                                  return _c("path", {
                                    key: i,
                                    attrs: {
                                      d: f.d,
                                      fill: f.fill,
                                      stroke: "#FFFFFF",
                                      "stroke-width": "1.5",
                                      opacity: f.opacidade,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return f.onClick()
                                      },
                                    },
                                  })
                                }
                              ),
                              _vm._l(
                                _vm.titulacaoPieReal.rotulos,
                                function (r, i) {
                                  return _c(
                                    "text",
                                    {
                                      key: "t" + i,
                                      attrs: {
                                        x: r.x,
                                        y: r.y,
                                        fill: r.fill,
                                        "font-size": "11",
                                        "font-weight": "500",
                                        "text-anchor": "middle",
                                      },
                                    },
                                    [_vm._v(_vm._s(r.texto))]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "sc-legend-row" },
                            _vm._l(
                              _vm.titulacaoPieReal.legenda,
                              function (l, i) {
                                return _c(
                                  "button",
                                  {
                                    key: i,
                                    staticClass: "sc-legend-item",
                                    style: {
                                      color: l.cor,
                                      background: l.fundo,
                                      opacity: l.opacidade,
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return l.onClick()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "sc-legend-dot",
                                      style: { background: l.ponto },
                                    }),
                                    _vm._v(_vm._s(l.label) + " "),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "ds-card sc-chart-card sc-chart-card--wide",
                          },
                          [
                            _c("div", { staticClass: "sc-chart-header" }, [
                              _c("div", { staticClass: "sc-chart-title" }, [
                                _vm._v(
                                  "Quantidade de Professores por Curso e Titulação"
                                ),
                              ]),
                              _c("div", { staticClass: "sc-chart-controls" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "sc-field",
                                    staticStyle: {
                                      flex: "1 1 180px",
                                      "min-width": "150px",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("Buscar curso"),
                                    ]),
                                    _c("ds-input", {
                                      attrs: {
                                        icon: "search",
                                        placeholder: "Nome do curso",
                                        value: _vm.cursoBusca,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.setCursoBusca($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "sc-field",
                                    staticStyle: { flex: "0 1 auto" },
                                  },
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("Ordenação"),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "sc-order-buttons" },
                                      _vm._l(_vm.ordemBotoes, function (o) {
                                        return _c(
                                          "button",
                                          {
                                            key: o.value,
                                            staticClass: "sc-order-btn",
                                            style: {
                                              color: o.cor,
                                              background: o.fundo,
                                            },
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setCursoOrdem(
                                                  o.value
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(o.label))]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "sc-bars" },
                              _vm._l(
                                _vm.titulacaoChart.grupos,
                                function (g, gi) {
                                  return _c(
                                    "div",
                                    { key: gi, staticClass: "sc-bars__group" },
                                    _vm._l(g.barras, function (b, bi) {
                                      return _c(
                                        "button",
                                        {
                                          key: bi,
                                          staticClass: "sc-bars__bar",
                                          style: { opacity: b.opacidade },
                                          attrs: {
                                            type: "button",
                                            title: b.title,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return b.onClick()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "sc-bars__value",
                                              style: { color: b.cor },
                                            },
                                            [_vm._v(_vm._s(b.valor))]
                                          ),
                                          _c("span", {
                                            staticClass: "sc-bars__col",
                                            style: {
                                              height: b.altura,
                                              background: b.cor,
                                            },
                                          }),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                }
                              ),
                              0
                            ),
                            _c(
                              "div",
                              { staticClass: "sc-bars-labels" },
                              _vm._l(
                                _vm.titulacaoChart.grupos,
                                function (g, gi) {
                                  return _c(
                                    "div",
                                    {
                                      key: gi,
                                      staticClass: "sc-bars-labels__item",
                                      attrs: { title: g.curso },
                                    },
                                    [_c("span", [_vm._v(_vm._s(g.rotulo))])]
                                  )
                                }
                              ),
                              0
                            ),
                            _c("div", { staticClass: "sc-chart-footer" }, [
                              _c("span", { staticClass: "sc-muted-label" }, [
                                _vm._v(_vm._s(_vm.cursosTexto)),
                              ]),
                              _c(
                                "div",
                                { staticClass: "sc-chart-footer__actions" },
                                [
                                  _c(
                                    "ds-button",
                                    {
                                      attrs: { variant: "quiet", size: "sm" },
                                      on: { click: _vm.alternarCursosTodos },
                                    },
                                    [_vm._v(_vm._s(_vm.cursosRotuloTodos))]
                                  ),
                                  _c(
                                    "ds-button",
                                    {
                                      attrs: {
                                        variant: "secondary",
                                        size: "sm",
                                      },
                                      on: { click: _vm.cursoPaginaAnterior },
                                    },
                                    [_vm._v("Anterior")]
                                  ),
                                  _c(
                                    "ds-button",
                                    {
                                      attrs: {
                                        variant: "secondary",
                                        size: "sm",
                                      },
                                      on: { click: _vm.cursoPaginaProxima },
                                    },
                                    [_vm._v("Próxima")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "ds-card sc-ranking-card" }, [
                        _c("div", { staticClass: "sc-chart-title" }, [
                          _vm._v("% Mestres e Doutores por Curso"),
                        ]),
                        _c("div", { staticClass: "sc-chart-subtitle" }, [
                          _vm._v(
                            "Quantidade de professores mestres e doutores sobre a base total de docentes ativos vinculados ao curso."
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "sc-ranking-grid" },
                          _vm._l(_vm.ranking, function (r, i) {
                            return _c(
                              "button",
                              {
                                key: i,
                                staticClass: "sc-ranking-row",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setCurso(r.ref)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "sc-ranking-row__nome" },
                                  [_vm._v(_vm._s(r.curso))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sc-progress-track sc-progress-track--sm",
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "sc-progress-fill",
                                      style: { width: r.largura },
                                    }),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "sc-ranking-row__valor" },
                                  [_vm._v(_vm._s(r.texto))]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sc-chart-footer sc-chart-footer--top",
                          },
                          [
                            _c("span", { staticClass: "sc-muted-label" }, [
                              _vm._v(_vm._s(_vm.cursosTexto)),
                            ]),
                            _c(
                              "div",
                              { staticClass: "sc-chart-footer__actions" },
                              [
                                _c(
                                  "ds-button",
                                  {
                                    attrs: { variant: "quiet", size: "sm" },
                                    on: { click: _vm.alternarCursosTodos },
                                  },
                                  [_vm._v(_vm._s(_vm.cursosRotuloTodos))]
                                ),
                                _c(
                                  "ds-button",
                                  {
                                    attrs: { variant: "secondary", size: "sm" },
                                    on: { click: _vm.cursoPaginaAnterior },
                                  },
                                  [_vm._v("Anterior")]
                                ),
                                _c(
                                  "ds-button",
                                  {
                                    attrs: { variant: "secondary", size: "sm" },
                                    on: { click: _vm.cursoPaginaProxima },
                                  },
                                  [_vm._v("Próxima")]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "sc-section-static" },
                  [
                    _c("ds-icon", {
                      attrs: {
                        name: "groups",
                        size: 22,
                        color: "var(--blue-700)",
                      },
                    }),
                    _c("span", { staticClass: "sc-section-toggle__title" }, [
                      _vm._v("Docentes Ativos"),
                    ]),
                    _c("span", { staticClass: "sc-hr" }),
                  ],
                  1
                ),
                _c("div", { staticClass: "ds-card sc-table-card" }, [
                  _c("div", { staticClass: "sc-table-toolbar" }, [
                    _c("div", { staticClass: "sc-muted-label" }, [
                      _vm._v(_vm._s(_vm.totalTexto)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "sc-table-toolbar__actions" },
                      [
                        _c(
                          "div",
                          { staticStyle: { width: "300px" } },
                          [
                            _c("ds-input", {
                              attrs: {
                                icon: "search",
                                placeholder: "Buscar professor ou curso",
                                value: _vm.busca,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.setBusca($event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "ds-button",
                          {
                            attrs: {
                              variant: "secondary",
                              icon: "download",
                              disabled:
                                _vm.baixandoCsv ||
                                _vm.docentesCarregando ||
                                !_vm.tabela.linhas.length,
                              title:
                                "Baixa em CSV todos os docentes do recorte atual (não só a página exibida)",
                            },
                            on: { click: _vm.baixarDocentesCSV },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.baixandoCsv ? "Baixando…" : "Baixar CSV"
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "sc-table-scroll" }, [
                    _c("table", { staticClass: "sc-table" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _vm._l(_vm.colunas, function (col) {
                              return _c(
                                "th",
                                {
                                  key: col.key,
                                  style: {
                                    width: col.width,
                                    textAlign: col.align,
                                  },
                                  attrs: { title: col.title },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortBy(col.key)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(col.header) + _vm._s(col.seta))]
                              )
                            }),
                            _c(
                              "th",
                              {
                                staticClass: "sc-th-static",
                                staticStyle: {
                                  width: "7%",
                                  "text-align": "center",
                                },
                                attrs: {
                                  title:
                                    "Histórico de alterações do indicador do docente (auditoria)",
                                },
                              },
                              [_vm._v("Logs")]
                            ),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.linhas, function (l, i) {
                          return _c("tr", { key: i }, [
                            _c(
                              "td",
                              { staticClass: "sc-td-ellipsis" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      bottom: "",
                                      "max-width": "420",
                                      "content-class": "sc-tooltip-cursos",
                                      disabled: !l.cursosLista.length,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  _vm._b(
                                                    {},
                                                    "span",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [_vm._v(_vm._s(l.curso))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  _vm._l(l.cursosLista, function (nome, ci) {
                                    return _c("div", { key: ci }, [
                                      _vm._v(_vm._s(nome)),
                                    ])
                                  }),
                                  0
                                ),
                              ],
                              1
                            ),
                            _c("td", { staticClass: "sc-td-wrap" }, [
                              _vm._v(_vm._s(l.nome)),
                            ]),
                            _c("td", { staticClass: "sc-td-ellipsis" }, [
                              _vm._v(_vm._s(l.titulacao)),
                            ]),
                            _c("td", { staticClass: "sc-td-ellipsis" }, [
                              _vm._v(_vm._s(l.regime)),
                            ]),
                            _c("td", { staticClass: "sc-td-ellipsis" }, [
                              _vm._v(_vm._s(l.vinculo)),
                            ]),
                            _c("td", [_vm._v(_vm._s(l.cargo))]),
                            _c("td", { staticClass: "sc-td-right" }, [
                              _vm._v(_vm._s(l.chSala)),
                            ]),
                            _c("td", { staticClass: "sc-td-right" }, [
                              _vm._v(_vm._s(l.chExtra)),
                            ]),
                            _c(
                              "td",
                              { staticClass: "sc-td-right sc-td-heading" },
                              [_vm._v(_vm._s(l.ch))]
                            ),
                            _c(
                              "td",
                              { staticClass: "sc-td-center" },
                              [
                                _c("audit-log-button", {
                                  attrs: {
                                    "table-name": "teacher_indicators",
                                    "tool-tip":
                                      "Logs do indicador do professor",
                                    "context-id": l.teacherId,
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _vm.docentesCarregando
                    ? _c("div", { staticClass: "sc-table-empty" }, [
                        _vm._v("Carregando docentes…"),
                      ])
                    : _vm.semLinhas
                    ? _c("div", { staticClass: "sc-table-empty" }, [
                        _vm._v("Nenhum registro encontrado"),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "sc-table-footer" }, [
                    _c(
                      "div",
                      { staticClass: "sc-pager-size" },
                      [
                        _c("span", { staticClass: "sc-muted-label" }, [
                          _vm._v("Linhas por página"),
                        ]),
                        _c("ds-select", {
                          attrs: {
                            options: _vm.porPaginaOpts,
                            value: _vm.porPagina,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.setPorPagina($event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c("span", { staticClass: "sc-muted-label" }, [
                      _vm._v(_vm._s(_vm.paginaTexto)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "sc-pager" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "sc-page-btn",
                            attrs: {
                              type: "button",
                              disabled: _vm.tabela.pagina <= 0,
                              title: "Primeira página",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.irParaPagina(0)
                              },
                            },
                          },
                          [_vm._v("«")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "sc-page-btn",
                            attrs: {
                              type: "button",
                              disabled: _vm.tabela.pagina <= 0,
                              title: "Página anterior",
                            },
                            on: { click: _vm.paginaAnterior },
                          },
                          [_vm._v("‹")]
                        ),
                        _vm._l(_vm.paginasBotoes, function (b, i) {
                          return [
                            b.reticencias
                              ? _c(
                                  "span",
                                  { key: "r" + i, staticClass: "sc-page-gap" },
                                  [_vm._v("…")]
                                )
                              : _c(
                                  "button",
                                  {
                                    key: "p" + b.n,
                                    staticClass: "sc-page-btn",
                                    class: { "sc-page-btn--ativo": b.ativo },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.irParaPagina(b.n - 1)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(b.n))]
                                ),
                          ]
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "sc-page-btn",
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.tabela.pagina >=
                                _vm.tabela.totalPaginas - 1,
                              title: "Próxima página",
                            },
                            on: { click: _vm.paginaProxima },
                          },
                          [_vm._v("›")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "sc-page-btn",
                            attrs: {
                              type: "button",
                              disabled:
                                _vm.tabela.pagina >=
                                _vm.tabela.totalPaginas - 1,
                              title: "Última página",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.irParaPagina(
                                  _vm.tabela.totalPaginas - 1
                                )
                              },
                            },
                          },
                          [_vm._v("»")]
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ],
              2
            ),
            _vm.paramAberto
              ? _c(
                  "div",
                  { staticClass: "sc-overlay", on: { click: _vm.fecharParam } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "sc-param-dialog",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "sc-param-dialog__header" },
                          [
                            _c("ds-icon", {
                              attrs: {
                                name: "tune",
                                size: 22,
                                color: "var(--blue-700)",
                              },
                            }),
                            _c(
                              "h3",
                              { staticClass: "sc-param-dialog__title" },
                              [_vm._v("Parametrizações dos Indicadores")]
                            ),
                            _c("ds-icon-button", {
                              attrs: { icon: "close", label: "Fechar" },
                              on: { click: _vm.fecharParam },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sc-param-dialog__subtitle" },
                          [
                            _vm._v(
                              "Metas do regimento interno, sobre a base de docentes ativos."
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sc-param-section",
                            staticStyle: {
                              "border-left-color": "var(--blue-700)",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "sc-param-section__title" },
                              [
                                _c("span", [_vm._v("Metas mínimas")]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "sc-info-icon",
                                    attrs: {
                                      title:
                                        "Referência MEC — universidades: 1/3 em tempo integral e 1/3 com mestrado ou doutorado. Centros universitários: 1/5 em tempo integral e 1/3 com mestrado ou doutorado. Faculdades: sem cota global fixada em lei.",
                                    },
                                  },
                                  [
                                    _c("ds-icon", {
                                      attrs: { name: "info", size: 16 },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "sc-param-grid sc-param-grid--metas",
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("Perfil"),
                                    ]),
                                    _c("ds-select", {
                                      attrs: {
                                        options: _vm.perfilOpts,
                                        value: _vm.rascunho.perfil,
                                        disabled: !_vm.isInternal,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.setPerfil($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    attrs: {
                                      title:
                                        "Percentual mínimo de docentes em tempo integral sobre a base de ativos.",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("% tempo integral"),
                                    ]),
                                    _c("ds-input", {
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        max: "100",
                                        step: "0.1",
                                        value: _vm.rascunho.metaTI,
                                        disabled: !_vm.isInternal,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.setMetaTI($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    attrs: {
                                      title:
                                        "Percentual mínimo de mestres e doutores sobre a base de ativos.",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("% mestres e doutores"),
                                    ]),
                                    _c("ds-input", {
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                        max: "100",
                                        step: "0.1",
                                        value: _vm.rascunho.metaStricto,
                                        disabled: !_vm.isInternal,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.setMetaStricto($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "sc-param-note" }, [
                              _vm._v(_vm._s(_vm.perfilNota)),
                            ]),
                            _vm.perfilAvisoGravacao
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "sc-param-note",
                                    staticStyle: { "font-style": "italic" },
                                  },
                                  [_vm._v(_vm._s(_vm.perfilAvisoGravacao))]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sc-param-section",
                            staticStyle: {
                              "border-left-color": "var(--brand-cyan)",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "sc-param-section__title" },
                              [
                                _c("span", [
                                  _vm._v("Carga horária por regime"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "sc-info-icon",
                                    attrs: {
                                      title:
                                        "Atalho para as mesmas regras da tela Regras de Regime de Trabalho — CH mínima total (sala de aula + atividades) e percentual mínimo de CH de atividades, por regime de trabalho.",
                                    },
                                  },
                                  [
                                    _c("ds-icon", {
                                      attrs: { name: "info", size: 16 },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "sc-param-grid sc-param-grid--ch",
                              },
                              [
                                _c("span"),
                                _c("span", { staticClass: "sc-label" }, [
                                  _vm._v("CH mínima"),
                                ]),
                                _c("span", { staticClass: "sc-label" }, [
                                  _vm._v("% extraclasse"),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "sc-param-grid__linha-label" },
                                  [_vm._v("Horista")]
                                ),
                                _c("ds-input", {
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    step: "1",
                                    value: _vm.rascunho.hrMin,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.setHrMin($event)
                                    },
                                  },
                                }),
                                _c("ds-input", {
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max: "100",
                                    step: "1",
                                    value: _vm.rascunho.hrExtra,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.setHrExtra($event)
                                    },
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "sc-param-grid__linha-label" },
                                  [_vm._v("Tempo Parcial")]
                                ),
                                _c("ds-input", {
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    step: "1",
                                    value: _vm.rascunho.tpMin,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.setTpMin($event)
                                    },
                                  },
                                }),
                                _c("ds-input", {
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max: "100",
                                    step: "1",
                                    value: _vm.rascunho.tpExtra,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.setTpExtra($event)
                                    },
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "sc-param-grid__linha-label" },
                                  [_vm._v("Tempo Integral")]
                                ),
                                _c("ds-input", {
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    step: "1",
                                    value: _vm.rascunho.tiMin,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.setTiMin($event)
                                    },
                                  },
                                }),
                                _c("ds-input", {
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max: "100",
                                    step: "1",
                                    value: _vm.rascunho.tiExtra,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.setTiExtra($event)
                                    },
                                  },
                                }),
                                _c("span"),
                                _c(
                                  "span",
                                  {
                                    staticClass: "sc-param-note",
                                    staticStyle: {
                                      "grid-column": "2 / -1",
                                      "margin-top": "-2px",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.notaCh))]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sc-param-section",
                            staticStyle: {
                              "border-left-color": "var(--brand-navy)",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "sc-param-section__title" },
                              [_c("span", [_vm._v("Base de cálculo")])]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "sc-param-grid sc-param-grid--base",
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { title: _vm.notaCursoRef } },
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("Curso do docente"),
                                    ]),
                                    _c("ds-select", {
                                      attrs: {
                                        options: _vm.cursoRefOpts,
                                        value: _vm.rascunho.cursoRef,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.setCursoRef($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { attrs: { title: _vm.notaRegimeRef } },
                                  [
                                    _c("div", { staticClass: "sc-label" }, [
                                      _vm._v("Classificação do regime"),
                                    ]),
                                    _c("ds-select", {
                                      attrs: {
                                        options: _vm.regimeRefOpts,
                                        value: _vm.rascunho.regimeRef,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.setRegimeRef($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "sc-param-checkbox",
                                attrs: {
                                  title:
                                    "Desmarcado, docentes com licença vigente hoje (limitada ao período letivo) ficam fora da base de ativos.",
                                },
                              },
                              [
                                _c("ds-checkbox", {
                                  attrs: {
                                    checked: _vm.rascunho.licenciados,
                                    label: "Considerar docentes licenciados",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.setLicenciados($event)
                                    },
                                  },
                                }),
                                _c("span", { staticClass: "sc-param-note" }, [
                                  _vm._v(
                                    _vm._s(_vm.licenciadosNaBase) +
                                      " licenciados hoje"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm.paramMensagem
                          ? _c(
                              "div",
                              {
                                staticClass: "sc-param-note",
                                style: {
                                  color: _vm.paramErro
                                    ? "var(--danger)"
                                    : "var(--success)",
                                },
                              },
                              [_vm._v(_vm._s(_vm.paramMensagem))]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "sc-param-dialog__footer" },
                          [
                            _c(
                              "ds-button",
                              {
                                attrs: {
                                  variant: "quiet",
                                  icon: "restart_alt",
                                },
                                on: { click: _vm.restaurarParam },
                              },
                              [_vm._v("Restaurar referência MEC")]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  gap: "var(--space-3)",
                                },
                              },
                              [
                                _c(
                                  "ds-button",
                                  {
                                    attrs: {
                                      variant: "secondary",
                                      disabled: _vm.salvandoParam,
                                    },
                                    on: { click: _vm.fecharParam },
                                  },
                                  [_vm._v("Cancelar")]
                                ),
                                _c(
                                  "ds-button",
                                  {
                                    attrs: { disabled: _vm.salvandoParam },
                                    on: { click: _vm.aplicarParam },
                                  },
                                  [_vm._v(_vm._s(_vm.textoBotaoAplicar))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }